import { Commit } from "vuex";

export const addModal = async ({ commit }: { commit: Commit }, id: string) => {
  commit("ADD_MODAL", id);
};
export const removeModal = async (
  { commit }: { commit: Commit },
  id: string
) => {
  commit("REMOVE_MODAL", id);
};
export const selectModal = async (
  { commit }: { commit: Commit },
  id: string
) => {
  commit("SELECT_MODAL", id);
};
